import {
    ApiResponse,
    TokenData,
    City,
    CityZone,
    CityLocation,
    RequirementRejectReason,
} from "../models";
import * as http from "./http";
import ApiService from "./service";

export class AddNewRequirementService extends ApiService {
    public async loadAllCities() {
        const url = `${this.apiDomain}/api/city`;

        const resposne = await http.get<ApiResponse<City[]>>(url, this.store);
        return resposne?.data?.data;
    }

    public async getCityZones(id?: string) {
        const url = `${this.apiDomain}/api/cityZone/city/${id}`;
        const response = await http.get<ApiResponse<CityZone[]>>(url, this.store);
        return response?.data?.data;
    }

    public async getPreferedLocations(id?: string) {
        const url = `${this.apiDomain}/api/cityLocation/city/${id}`;
        const response = await http.get<ApiResponse<CityLocation[]>>(
            url,
            this.store
        );
        return response?.data?.data;
    }

    public async getPropertyType() {
        // const url = `${this.apiDomain}/api/propertyType?id=${id}`;
        const url = `${this.apiDomain}/api/propertyType`;
        const response = await http.get<ApiResponse<any>>(url, this.store);
        return response?.data?.data;
    }

    public async getProposal() {
        const url = `${this.apiDomain}/api/propertyType`;
        const response = await http.get<ApiResponse<any>>(url, this.store);
        return response?.data?.data;
    }

    public async getProjectType() {
        const url = `${this.apiDomain}/api/projectType`;
        const response = await http.get<ApiResponse<any>>(url, this.store);
        return response?.data?.data;
    }

    public async createRequirements(params: any) {
        const url = `${this.apiDomain}/api/requirement`;
        const response = await http.post<ApiResponse<any>>(url, params, this.store);
        return response?.data.data;
    }

    public async updateRequirements(params: any, id: string) {
        const url = `${this.apiDomain}/api/requirement/${id}`;
        const response = await http.put<ApiResponse<any>>(url, params, this.store);
        return response?.data?.data;
    }

    public async getFacilityType() {
        const url = `${this.apiDomain}/api/facility-type`;
        const response = await http.get<ApiResponse<any>>(url, this.store);
        return response?.data?.data;
    }

    public async getPreferredFloor() {
        const url = `${this.apiDomain}/api/floor/names`;
        const response = await http.get<ApiResponse<any>>(url, this.store);
        return response?.data.data;
    }

    public async getPreferredDevelopers(params: any) {
        const url = `${this.apiDomain}/api/developer/search`;
        const response = await http.post<ApiResponse<any>>(url, params, this.store);
        return response?.data?.data;
    }

    public async getPreferredProject(params: any) {
        const url = `${this.apiDomain}/api/project/search`;
        const response = await http.post<ApiResponse<any>>(url, params, this.store);
        return response?.data?.data;
    }

    public async getAmenity(params: any) {
        const url = `${this.apiDomain}/api/amenity/search`;
        const response = await http.post<ApiResponse<any>>(url, params, this.store);
        return response?.data.data;
    }

    public async approveStatus(params: any) {
        const url = `${this.apiDomain}/api/requirement/status`;
        const response = await http.post<ApiResponse<any>>(url, params, this.store);
        return response?.data;
    }

    public async rejectStatus(params: any) {
        const url = `${this.apiDomain}/api/requirement/status`;
        const response = await http.post<ApiResponse<any>>(url, params, this.store);
        return response?.data;
    }

    public async revokeStatus(params: any) {
        const url = `${this.apiDomain}/api/requirement/status`;
        const response = await http.post<ApiResponse<any>>(url, params, this.store);
        return response?.data;
    }

    public async requirementVersionsComparisons(params: any) {
        const url = `${this.apiDomain}/api/requirement/compare`;
        const response = await http.post<ApiResponse<any>>(
            url,
            params,
            this.store
        );
        return response?.data
    }

    public async loadAllRequirementRejectReason(data: any) {
        const url = `${this.apiDomain}/api/reasons/list`;

        const resposne = await http.post<ApiResponse<RequirementRejectReason[]>>(
            url,
            data,
            this.store
        );
        return resposne?.data?.data;
    }
    public async updateRequirementRejectReason(data: any, id?: string) {
        const url = `${this.apiDomain}/api/reasons/${id}`;

        const response = await http.put<ApiResponse<TokenData>>(
            url,
            data,
            this.store
        );
        return response.data;
    }

    public async createRequirementRejectReason(data: any, id?: string) {
        const url = `${this.apiDomain}/api/reasons`;

        const response = await http.post<ApiResponse<TokenData>>(
            url,
            data,
            this.store
        );
        return response.data;
    }

    public async deleteRequirementRejectReason(id?: string) {
        const url = `${this.apiDomain}/api/reasons/${id}`;

        const response = await http.remove<ApiResponse<any>>(
            url,
            this.store
        );
        return response.data;
    }


}
